import { Box, Button, Typography, Card, CardContent, PublicOutlinedIcon, PublicOffOutlinedIcon, 
  AddIcon, Link } from 'src/components';
import { useAuth } from 'src/utils';
import { useIsMobile } from 'src/hooks';

import placeholderImage from 'src/assets/placeholders/grey-300x200.png';

export default function TripsList({ isPublicPortal, trips = [], handleViewChange, setDrawerState }) {
  const isEmpty = trips.length === 0;
  const { user } = useAuth();
  const isMobile = useIsMobile();

  if (!user && !isPublicPortal) {
    return;
  }

  const handleTripClicked = (trip) => {
    handleViewChange('TripDetails', trip);
    if (isMobile) {
      setDrawerState("half");
    }
  };

  const handleAddTripClicked = (polarsteps = false) => {
    handleViewChange('AddTrip', null, null, polarsteps);
    if (isMobile) {
      setDrawerState("expanded");
    }
  };

  return (
    <Box className="scrollBox" sx={{ pr: 2, height: '100%' }}>
      {!isEmpty && !isPublicPortal && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
          <Button
            variant="text"
            disableRipple
            size="small"
            startIcon={<AddIcon fontSize="small" />}
            onClick={() => handleAddTripClicked()}
          >
            Add Another Trip
          </Button>
        </Box>
      )}

      {isEmpty && user && !isPublicPortal ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 4 }}>
          <Typography
            variant="subtitle1"
            color="text.secondary"
            sx={{mb: 2, width: '230px', textAlign: 'center', lineHeight: 1.4 }}
          >
            Starting tracking your epic roadtrip today, every mile tracked.
          </Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => handleAddTripClicked()}
            sx={{ width: '70%' }}
          >
            Add a Trip
          </Button>
          <Typography variant={"body2"} color="text.secondary" fontWeight={500} sx={{mt: 3}}> 
              Already using
              <Link underline={"none"} variant={"body2"} fontWeight={600} sx={{ml: '3px'}} onClick={() => handleAddTripClicked(true)} >
                Something Else?
            </Link>
          </Typography> 
        </Box>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, pt: 0, mt: isPublicPortal ? 2 : 0 }}>
          {trips.map((trip) => {
            const stepCount = isPublicPortal ? trip.steps?.length : trip.stepCount;
            return (
              <Card
                key={trip.id}
                onClick={() => handleTripClicked(trip)}
                sx={{
                  position: 'relative',
                  height: 200,
                  cursor: 'pointer',
                  borderRadius: 2,
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  justifyContent: 'flex-end',
                }}
              >
                {/* Image with opacity */}
                <Box
                  component="img"
                  src={trip.coverImageUrl || placeholderImage}
                  alt={trip.name}
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    opacity: 0.7,
                    zIndex: 0,
                    pointerEvents: 'none', // So clicks go through to card
                  }}
                />
                {/* Overlay */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'rgba(0, 0, 0, 0.2)',
                  }}
                />

                <CardContent
                  sx={{
                    position: 'relative',
                    color: '#fff',
                    background: 'linear-gradient(to top, rgba(0,0,0,0.4), rgba(0,0,0,0))'
                  }}
                >
                  <Typography variant="h4" fontWeight={600}>
                    {trip.name}
                  </Typography>

                  <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        mt: 1,
                        width: '100%',
                        alignItems: 'center'
                    }}
                    >
                        {/* Date Column */}
                        <Box display="flex" textAlign="center" >
                            <Typography variant="body2" fontWeight={600}>{new Date(trip.startDate).toLocaleString('default', { month: 'short' })} {new Date(trip.startDate).getFullYear()}</Typography>
                        </Box>

                        {/* Steps Column */}
                        <Box textAlign="center">
                            <Typography variant="body2" fontWeight={600}>{stepCount || 0} steps</Typography>
                        </Box>

                        <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                            {!isPublicPortal && (<>
                              {trip.privacy === "Public" ? <PublicOutlinedIcon fontSize="small" /> : <PublicOffOutlinedIcon fontSize="small" />}
                              <Typography variant="body2" fontWeight={600}>{trip.privacy}</Typography>
                            </>)}
                        </Box>
                        
                    </Box>

                </CardContent>
              </Card>
            );
          })}
        </Box>
      )}

    </Box>
  );
}

